module.exports = __webpack_public_path__ + "static/media/RI-D5-0.4-043.110efa1b.webp";